import * as ActionTypes from './actions';
import { FleetState, FleetAction } from './types';

const createInitialState = (): FleetState => ({
  cards: [],
  loading: false
});

// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = createInitialState(),
  action: FleetAction
): FleetState {
  switch (action.type) {
    case ActionTypes.MY_FLEET_LOADING: {
      return { ...state, loading: true };
    }
    case ActionTypes.MY_FLEET_LOADED: {
      return { ...state, loading: false, cards: action.cards };
    }
    default: {
      return { ...state, loading: false };
    }
  }
}
